module.exports = __webpack_public_path__ + "img/bz-y.24030208.png";